import { OrderCostSummaryV2Props } from "../index";
import React, { ComponentType, Fragment } from "react";
import Row from "../../../../../components/Common/Row";
import Col from "../../../../../components/Common/Col";
import { formatCurrency } from "../../../../../utils/Format";
import { serviceChargeCost, serviceChargeCostDiscount } from "../../../../../utils/Cost";
import { OrderCategory, OrderStatus, TOrderCostV6 } from "../../../../../api/endpoints/Order";

const labelMapping = {
  [OrderCategory.REALTIME]: 'Service Charge (Volume and Service Package)',
  [OrderCategory.EU_CUTOUT]: 'Service Charge (Volume and Service Package)',
  [OrderCategory.ARCHIVE]: 'Annual ECMWF handling charge',
  [OrderCategory.WEB]: 'Annual ECMWF handling charge',
}

interface Props extends Omit<OrderCostSummaryV2Props, 'cost'> {
  cost: OrderCostSummaryV2Props['cost'];
  component?: ComponentType<{ label: string, value: string }>;
  preview?: boolean;
}

const Item = (props: { label: string, value: string }) => {
  const { label, value } = props;
  return (
    <Row>
      <Col sm={12} md={10}>
        {label}
      </Col>
      <Col sm={12} md={2}>
        {value}
      </Col>
    </Row>
  )
}

const ServiceChargeCost = (props: Props) => {
  const { cost, orderCategory, orderStatus, component, preview } = props;
  const { total_cost } = cost.data;

  if (!preview && (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) && orderStatus === OrderStatus.DRAFT) {
    return null;
  }

  if (!total_cost) {
    return null;
  }

  const isDiscounted = total_cost.service_charge !== total_cost.service_charge_after_discount;
  const Component = component ? component : Item;

  return (
    <Fragment>
      <Component label={labelMapping[orderCategory]} value={formatCurrency(serviceChargeCost(cost))} />

      {
        isDiscounted &&
        <Component
          label="Applicable discount"
          value={formatCurrency(serviceChargeCostDiscount(cost))}
        />
      }
    </Fragment>
  )
}

export default ServiceChargeCost;
